import React from "react";

export const Footer = () => {
    return (
        <div className="px-8 py-8 flex justify-center items-center">
            <p className="font-afacad text-sm text-center"><b>HS-POL Group</b> - Twój partner w skupie złomu i recyklingu. © 2021 Wszelkie prawa zastrzeżone.</p>
        </div>
    )
}